import { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import './FAQ.scss';
import { getSellerHeaders, getSellerUrl } from 'shared/http';
import { jiraConfluencePageContentView } from 'shared/settings/apiconfig';
import { NoData } from 'features/components/redirect/NoData';

class FAQArticleDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: false,
            article: null,
            pageError: '',
            errorpageredirect: false,
            errorType: ''
        };
    }

    componentDidMount() {
        this.loadArticle();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.pageid !== this.props.match.params.pageid) {
            this.loadArticle();
        }
    }

    getArticleId = () => this.props.match.params.pageid;

    getResponseData = (response) => {
        const responseData = response?.data;

        return responseData?.data || responseData || null;
    }

    setApiError = (error, fallbackMessage) => {
        const status = error?.response?.status;

        if (status === 401 || status === 404) {
            this.setState({
                errorpageredirect: true,
                errorType: status === 401 ? 'expiryError' : 'noData',
                pageLoading: false
            });
            return;
        }

        this.setState({
            article: null,
            pageError: fallbackMessage,
            pageLoading: false
        });
    }

    loadArticle = () => {
        const articleId = this.getArticleId();

        if (!articleId) {
            this.setState({ article: null, pageError: 'Article not found.' });
            return;
        }

        this.setState({ pageLoading: true, pageError: '' });

        axios.get(getSellerUrl(`${jiraConfluencePageContentView}${articleId}`), getSellerHeaders())
            .then(response => {
                this.setState({
                    article: this.getResponseData(response),
                    pageLoading: false
                });
            })
            .catch(error => this.setApiError(error, 'Article content is not available.'));
    }

    handleBack = () => {
        const { history, location } = this.props;
        const returnTo = location?.state?.returnTo;
        const returnState = location?.state?.returnState;

        if (returnTo && returnState) {
            history.replace(returnTo, returnState);
            return;
        }

        history.goBack();
    }

    renderArticle = () => {
        const { article, pageError } = this.state;
        const title = article?.title || 'Help Article';
        const content = article?.content || article?.htmlContent || article?.body || '';

        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');

        doc.querySelectorAll('a').forEach((link) => {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        });

        const updatedContent = doc.body.innerHTML;

        return (
            <div className="help-center-shell help-article-shell help-article-detail-shell">
                <button
                    type="button"
                    className="help-back-link"
                    onClick={this.handleBack}
                >
                    <i className="fas fa-arrow-left"></i>
                </button>
                <h1>{title}</h1>
                {content ? (
                    <div className="help-article-content" dangerouslySetInnerHTML={{ __html: updatedContent }} />
                ) : (
                    <div className="help-empty-state">{pageError || 'Article content is not available.'}</div>
                )}
            </div>
        );
    }

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />;
        }

        return (
            <div className="faq-help-page">
                {this.state.pageLoading ? (
                    <div className="loader d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div>
                ) : this.renderArticle()}
            </div>
        );
    }
}

export default connect(state => state)(FAQArticleDetail);
